import React from 'react';

import { QueryResult } from '@apollo/client';

import { AccountDetailsError } from './AccountDetailsError';
import { AccountDetailsLoaded } from './AccountDetailsLoaded';
import { AccountDetailsLoading } from './AccountDetailsLoading';

import { PurchaseOrderAccountHoldingsQuery } from '../graphql/query.purchaseOrderaccountHoldings.generated';

interface Props {
  accountHoldingsResult: Pick<QueryResult<PurchaseOrderAccountHoldingsQuery>, 'loading' | 'data' | 'error'>;
  subAccountName: string;
}

export const AccountDetailsStateSwitch: React.FC<Props> = ({ accountHoldingsResult, subAccountName }) => {
  if (accountHoldingsResult.loading && !accountHoldingsResult.data) {
    return <AccountDetailsLoading />;
  }

  const account = accountHoldingsResult.data?.managedAccount;

  if (accountHoldingsResult.error || !account) {
    return <AccountDetailsError />;
  }

  return <AccountDetailsLoaded account={account} subAccountName={subAccountName} />;
};
